/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "app/theme/base/colors";
import borders from "app/theme/base/borders";
import typography from "app/theme/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "app/theme/functions/pxToRem";

const { inputBorderColor, primary, grey, light, white, text } = colors;
const { borderRadius } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      fontSize: size.sm,
      borderRadius: borderRadius.lg,

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: inputBorderColor,
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: primary.main,
          borderWidth: 1,
        },
      },

      "&.Mui-disabled": {
        backgroundColor: light.main,
        color: text.secondary,
      },
    },

    notchedOutline: {
      borderColor: inputBorderColor,
    },

    input: {
      color: text.primary,
      padding: pxToRem(12),
      backgroundColor: "transparent",

      "&.Mui-disabled": {
        color: grey[500],
        WebkitTextFillColor: grey[500],
      },
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10),
    },

    multiline: {
      color: text.primary,
      padding: 0,
    },
  },
};

export default inputOutlined;
